import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { v4 as SessionID } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class ExistingvendorService {
  public _ExistingvendorService = environment.ExistingvendorService;
  public _httpOptions;
  public sessionId : string
  constructor(private http: HttpClient) { 
    this.sessionId = sessionStorage["SessionId"]
    this._httpOptions = {
      headers: new HttpHeaders({ 'SessionId':this.sessionId })
    };
  
  }

  GetById(customercode:string): Observable<any>{
  

    var Query = this._ExistingvendorService + '/GetById' +'/'+ customercode ;
    // console.log(Query);
    return this.http.get<{ data: any }>(Query,this._httpOptions);
  }
  
  UpsertCustomerSiteVendor(customersite: object) {
   

    // console.log("Create");
    var Query = this._ExistingvendorService;
    return this.http.post<{ data: any }>(Query, customersite,this._httpOptions);
  }
}

